export const currencySymbol = "₺";

export const formatCurrency = (
  value: number | undefined | null | string,
  fractionDigits: number = 2
) => {
  if (value === undefined || value === null || value === 0) {
    value = 0;
  }

  if (typeof value === "string") {
    value = parseFloat(value);
  }

  return new Intl.NumberFormat(undefined, {
    style: "decimal",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
};

// Manual credit top-ups are always whole numbers, so a fixed ",00" on every row
// is noise. Betting and casino consumption CAN leave a fraction on a credit
// balance though, and rounding that away would misreport real money — so the
// decimals appear only when the value actually has them.
export const formatAmountSmart = (
  value: number | undefined | null | string
): string => {
  const numeric = typeof value === "string" ? parseFloat(value) : (value ?? 0);
  const hasFraction = Number.isFinite(numeric) && !Number.isInteger(numeric);
  return formatCurrency(numeric, hasFraction ? 2 : 0);
};
